import { defineFcm } from '../shared/factory';

export const FCM_SAP_SCOPE_LOCATION_INFERENCE = defineFcm('sap_scope_location_inference')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		// Locale-scoped so the value can be set per locale (e.g. en-US only); unset locales fall to the
		// `false` default. The inference prompt is English-only, so this rolls out to en-US first.
		supportedGroups: { locales: true },
		context: 'SAP scope/location inference',
		description:
			'Toggles the background scope/location inference call in the Start a Petition (SAP) AI flow. When on, SAP fires the `inferPetitionScopeLocation` mutation after the personal-story step and tracks the result. Does not gate the mutation itself. Locale-scoped (en-US first). CHANGE-97331',
		import: false,
	});
